import { Component, OnInit } from '@angular/core'
import { AuthManager } from '../shared/auth/AuthManager'
import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'

@Component({
   selector: 'app-login',
   templateUrl: './login.component.html',
   styleUrls: ['./login.component.scss'],
   standalone: false,
})
export class LoginComponent implements OnInit {
   submitting: boolean
   notFound: boolean

   constructor(private authMgr: AuthManager, private router: Router, private toastrSvc: ToastrService) {}

   ngOnInit(): void {}

   logIn() {
      this.submitting = true
      this.notFound = false
      this.authMgr.logInWithEntra().subscribe({
         next: (res) => {
            if (res?.success) {
               this.router.navigate(['/'])
            } else {
               this.notFound = true
            }
            this.submitting = false
         },
         error: (err) => {
            // user closing the Microsoft popup is not a server error
            if (err?.errorCode === 'user_cancelled') {
               this.submitting = false
               return
            }
            console.error(err)
            this.toastrSvc.error("We couldn't log you in. Please try again.")
            this.submitting = false
         },
      })
   }
}
